import { useContext } from "react";
import { DataSourceContextValue } from "./types";
import { DataSourceContext } from "./Provider";

export function useDataSource(): DataSourceContextValue {
  const ctx = useContext(DataSourceContext);

  if (ctx != null) {
    return ctx;
  } else {
    throw new Error("Provider not initialised");
  }
}
